import classNames from "classnames";
import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
	root: ({ direction, justifyContent, alignItems, flex, gap }) => ({
		display: "flex",
		flexDirection: direction,
		justifyContent,
		alignItems,
		flex,
		gap,
	}),
}));

const Flex = ({ children, rootClass, style, ...flexProps }) => {
	const { root } = useStyles(flexProps);

	return (
		<div style={style} className={classNames(root, rootClass)}>
			{children}
		</div>
	);
};

export default Flex;
